import { h } from "preact";
import punycode from "punycode";

const TextWithLinks = ({ text }) => {
  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|[^\s]+\.[^\s]{2,})/g;

  return text.split(urlRegex).reduce((acc, part, index, array) => {
    if (urlRegex.test(part)) {
      let href = part.trim();
      const lastChar = href[href.length - 1];

      if (",.!?:;".includes(lastChar)) {
        href = href.slice(0, -1);
      }

      try {
        const urlObj = new URL(href);
        let displayText = urlObj.hostname;
        displayText = punycode.toUnicode(displayText);

        acc.push(
          <a
            key={index}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline" }}
          >
            {displayText}
          </a>
        );

        if (",.!?:;".includes(lastChar)) {
          acc.push(lastChar);
        }
      } catch (e) {
        acc.push(part);
      }
    } else {
      acc.push(part);
    }

    if (index < array.length - 1) {
      acc.push(" ");
    }

    return acc;
  }, []);
};

export default TextWithLinks;
